var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _path3, _path4, _line27, _path5, _line28, _path6, _line29, _circle, _path7, _circle2, _path8, _line30, _line31, _rect, _line32, _line33, _line34, _line35, _line36, _path9, _line37, _line38, _path10, _line39, _line40, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeLongBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 200 35 C 3 40, 3 40, 3 100 C 3 160, 3 160, 200 165 Z",
    strokeWidth: 3,
    fill: "#aaa",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 200 39 C 100 44, 100 44, 100 44 L 100 156 C 100 156, 100 156, 200 161 Z",
    fill: "#955726"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 155,
    x2: 200,
    y2: 155,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 150,
    x2: 200,
    y2: 150,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 145,
    x2: 200,
    y2: 145,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 140,
    x2: 200,
    y2: 140,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 135,
    x2: 200,
    y2: 135,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 130,
    x2: 200,
    y2: 130,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 125,
    x2: 200,
    y2: 125,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 120,
    x2: 200,
    y2: 120,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 115,
    x2: 200,
    y2: 115,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 110,
    x2: 200,
    y2: 110,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 105,
    x2: 200,
    y2: 105,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 100,
    x2: 200,
    y2: 100,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 95,
    x2: 200,
    y2: 95,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 90,
    x2: 200,
    y2: 90,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 85,
    x2: 200,
    y2: 85,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 80,
    x2: 200,
    y2: 80,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 75,
    x2: 200,
    y2: 75,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 70,
    x2: 200,
    y2: 70,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 65,
    x2: 200,
    y2: 65,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 60,
    x2: 200,
    y2: 60,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 55,
    x2: 200,
    y2: 55,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 50,
    x2: 200,
    y2: 50,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 45,
    x2: 200,
    y2: 45,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 47,
    x2: 170,
    y2: 153,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 47,
    x2: 140,
    y2: 153,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 47,
    x2: 110,
    y2: 153,
    stroke: "#4d4137",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 190 70 L 155 72 L 155 128 L 190 130 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 155 80 L 165 80 L 165 90 L 155 90",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 85,
    x2: 120,
    y2: 85,
    stroke: "black",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 155 95 L 165 95 L 165 105 L 155 105",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 100,
    x2: 120,
    y2: 100,
    stroke: "black",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 155 110 L 165 110 L 165 120 L 155 120",
    stroke: "black",
    strokeWidth: 3,
    fill: "transparent"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 115,
    x2: 120,
    y2: 115,
    stroke: "black",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 10,
    cx: 80,
    cy: 145,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 40 140 L 120 155 L 123 150 L 43 135 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 10,
    cx: 80,
    cy: 55,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 40 60 L 120 45 L 123 50 L 43 65 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 95,
    x2: 90,
    y2: 95,
    stroke: "black",
    strokeWidth: 2
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 105,
    x2: 90,
    y2: 105,
    stroke: "black",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 93,
    width: 30,
    height: 14,
    fill: "#aaa",
    stroke: "black"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: 93,
    x2: 90,
    y2: 107,
    stroke: "black",
    strokeWidth: 1
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 93,
    x2: 95,
    y2: 107,
    stroke: "black",
    strokeWidth: 1
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 93,
    x2: 100,
    y2: 107,
    stroke: "black",
    strokeWidth: 1
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 105,
    y1: 93,
    x2: 105,
    y2: 107,
    stroke: "black",
    strokeWidth: 1
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 93,
    x2: 110,
    y2: 107,
    stroke: "black",
    strokeWidth: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 165 45 L 185 45 L 185 65 L 165 65 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 171.66,
    y1: 51.66,
    x2: 171.66,
    y2: 36.66,
    stroke: "black",
    strokeWidth: 2.5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 178.33,
    y1: 51.66,
    x2: 178.33,
    y2: 36.66,
    stroke: "black",
    strokeWidth: 2.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 165 155 L 185 155 L 185 135 L 165 135 Z",
    stroke: "black",
    strokeWidth: 3,
    fill: "#aaa"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 171.66,
    y1: 148.33,
    x2: 171.66,
    y2: 162.33,
    stroke: "black",
    strokeWidth: 2.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 178.33,
    y1: 148.33,
    x2: 178.33,
    y2: 162.33,
    stroke: "black",
    strokeWidth: 2.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 132,
    cy: 50,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 150,
    cy: 49,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 150,
    cy: 151,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 132,
    cy: 150,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 23,
    cy: 64,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 19,
    cy: 82,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 17,
    cy: 100,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 19,
    cy: 118,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 23,
    cy: 136,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), "\n  Sorry, your browser does not support inline SVG.\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeLongBack);
export default __webpack_public_path__ + "static/media/ThreeLongBack.50c66caa86f605f6f6178c9cccaa4f44.svg";
export { ForwardRef as ReactComponent };